//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from "moment";
import GenericModal from "@Shared/components/modals/generic-modal";
import MaterialInput from "@Shared/components/inputs/material-input";
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "RenameDocumentModal",
  components: {
    GenericModal,
    MaterialInput,
    SimpleButton
  },
  mixins: [validationMixin],
  validations: {
    newDocumentName: {
      required,
      maxLength: maxLength(255)
    }
  },
  props: {
    clientName: {
      type: String,
      default: ""
    },
    documentName: {
      type: String,
      default: ""
    },
    documentType: {
      type: String,
      default: ""
    },
    editingDocument: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      oldDocumentName: "",
      newDocumentName: ""
    };
  },
  computed: {
    fileExtension() {
      return `.${this.oldDocumentName.split(".").pop()}`;
    },
    newDocumentNameSuggestion() {
      return this.getNameSuggestion(this.clientName, this.documentType);
    }
  },
  methods: {
    getNameSuggestion(...append) {
      const extraData = append.join(" - ");
      return `${moment().format("MMM - YYYY - ")} ${extraData}`;
    },
    handleModalShow() {
      this.oldDocumentName = this.documentName;
      this.newDocumentName = this.newDocumentNameSuggestion;
    },
    handleModalHidden() {
      this.oldDocumentName = "";
      this.newDocumentName = "";
    },
    handleRenameDocument() {
      if (this.$v.$invalid) return;
      this.$emit("submit", {
        fileName: `${this.newDocumentName}${this.fileExtension}`
      });
      if (!this.editingDocument) {
        this.$hideModal();
      }
    }
  }
});